import React from "react";
import { createActionPlanTopic, getActionPlanSurveyTopics, updateActionPlanTopicData } from "../../../api/actionPlanClientApi";
import { Button } from "../../../designSystem/button/Button";
import { rng, SurveySegment, SurveyTopic } from '../../../amorg-common';
import { CloseModalButton } from "../../../designSystem/compositeComponents/CloseModalButton";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { LoadingPageOverlay } from "../../../designSystem/LoadingPageOverlay";
import { Modal } from "../../../designSystem/Modal";
import { Tabber } from "../../../designSystem/Tabber";
import { SurveyTopicInfoPanel } from "./SurveyTopicInfoPanel";
import { Card } from "../../../designSystem/Card";



type SurveyTopicListButtonProps = {
    actionPlanId:string,
    segmentFilter:SurveySegment[][]
    onUpdated: () => void
}
export function SurveyTopicListButton (props: SurveyTopicListButtonProps): JSX.Element
{
    const [surveyTopics, setSurveyTopics] = React.useState<SurveyTopic[]>([]);
    const [showSurveyTopics, setShowSurveyTopics] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    async function handleClickShowModal()
    {
        setLoading(true);
        setSurveyTopics(await getActionPlanSurveyTopics(props.actionPlanId));
        setLoading(false);
        setShowSurveyTopics(true);
    }

    async function handleClickCreateSurveyTopic (st: SurveyTopic)
        {
            const topicId = rng.getRandomId();
            setLoading(true);
            if ((await createActionPlanTopic(topicId, props.actionPlanId)).isSuccess)
            {
                if (((await updateActionPlanTopicData(topicId, { type: 'WPA', customData: { surveyTopicIdentifier: st } })).isSuccess))
                {
                    setShowSurveyTopics(false);
                    props.onUpdated();
                }
            }
            setLoading(false);
        }

    return (
        <>
            <LoadingPageOverlay loading={loading} />
            
            <Button
                variant="light"
                size={"42px"}
                onClick={handleClickShowModal}
                icon="actions_plus"
                text={"Vælg emne fra rapporten"}
                disabled={props.segmentFilter.length === 0}
                toolTipText={props.segmentFilter.length === 0 ? "Du skal vælge segmenter for at kunne vælge emner fra rapporten" : undefined}
                // disabled={surveyTopics.length === 0} 
            />
        
            {surveyTopics.length > 0 &&
                <Modal
                    title={"Emner fra spørgeskemaet"}
                    width={'60%'}
                    content={
                        <Flex flexDirection='column' gap={16}>
                            <ActionPlanSurveyTopicList
                                topics={surveyTopics}
                                onClickCreateTopic={handleClickCreateSurveyTopic} />
                            <CloseModalButton onClose={() => setShowSurveyTopics(false)} />
                        </Flex>
                    }
                    showModal={showSurveyTopics}
                    onCancel={() => setShowSurveyTopics(false)}
                />
            }
        </>
    );
}

type ActionPlanSurveyTopicListProps = {
    topics: SurveyTopic[],
    onClickCreateTopic: (st: SurveyTopic) => void
}
type TopicMode = 'theme' | 'indicator' | 'question'

function ActionPlanSurveyTopicList(props: ActionPlanSurveyTopicListProps): JSX.Element {
    const [mode, setMode] = React.useState<TopicMode>('theme');

    const selectedTopics = props.topics.filter(t => t.linkType === mode)
        .sort((a, b) => a.data.title.localeCompare(b.data.title));

    return (
        <>
            <div style={{margin:'10px'}}>
                <Tabber variant='default' items={[
                        {tabName:'question', text:'Spørgsmål'},
                        {tabName:'theme', text:'Temaer'},
                        {tabName:'indicator', text:'Indikatorer'}
                    ]}
                    selectedTabName={mode}
                    onClick={(tabName) => setMode(tabName as TopicMode)} 
                />
            </div>
            <Flex flexDirection="column" gap={16} style={{height:'60vh', overflowY:'scroll'}}>
                {selectedTopics.map((st, index) => {

                    return (
                        <div key={index}>
                            <Flex flexDirection="column" gap={2} style={{padding:'8px'}}>
                                <Card variant="outlined" padding="4px">
                                    <Flex alignItems="center" gap={8}>
                                        <SurveyTopicInfoPanel surveyTopic={st} small noCard />
                                    
                                        <Button variant="text"
                                            size="32px"
                                            onClick={() => props.onClickCreateTopic(st)}
                                            icon="actions_plus"
                                            text="Tilføj" />
                                    </Flex>
                                </Card>
                            </Flex>
                        </div>
                    );
                })}
            </Flex>
        </>
    );
}